<template>
  <div class="section-box">
    <el-tabs v-model="selectTab" type="card" class="customer-tabs-mg" :before-leave="tabSelect">
      <el-tab-pane v-for="(item, index) in tabArray" :label="item.value" :name="item.key" :key="index"></el-tab-pane>
    </el-tabs>
    <div class="customer-list">
      <el-row>
        <el-col :span="6">
          <el-radio-group v-model="form.targetType" style="" @input="selectTarget">
            <el-radio-button label="1">集团指标</el-radio-button>
            <el-radio-button label="2">大区指标</el-radio-button>
            <el-radio-button label="3">子公司指标</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="4" v-if="form.targetType!='1'">
          <el-input v-model="form.companyId"  placeholder="企业Id">
            <el-button slot="append" type="success" @click="inputSearch">搜索</el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>

    <!-- 列表 -->
    <el-table :stripe="true" :data="tableData" style="width: 100%;margin-top: 20px;" border v-loading="listLoading"
      :header-cell-style="{ background: '#F5F7FA' }">
      <!-- eslint-disable  -->
      <el-table-column label="企业Id" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.CompanyId || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="企业名称">
        <template slot-scope="scope">
          <span>{{ scope.row.CompanyName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="大区" v-if="form.targetType == '2'" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.AreaCategoryName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="指标金额" width="150" >
        <template slot-scope="scope"> 
          <el-input v-if="scope.row.editStatus&&scope.row.editStatus==1"  size="mini" v-model="scope.row.TargetAmount2" placeholder="请输入内容"></el-input>
          <span v-else>{{ scope.row.TargetAmount || '--' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作">
        <template slot-scope="scope">
      
          <el-button v-if="scope.row.editStatus==1" type="info" size="mini" @click="ediTarget(scope,0)">取消</el-button>
          <el-button v-if="scope.row.editStatus==1" type="success" size="mini" @click="saveTarget(scope)">保存</el-button>
          <el-button v-else type="primary" size="mini" @click="ediTarget(scope,1)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.pageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
 
  </div>
</template>

<script>

import axios from "axios";
import {
  UpdateCompanytTarget,
  GetCompanyTargetList,
  GetWord
} from "@/service/run";
export default {
  data() {
    return {
      selectTab: "3",
      tabArray: [{
        key: '1',
        value: "个人",
      }, {
        key: '2',
        value: "企业",
      }, {
        key: '3',
        value: "指标",
      }],

      listLoading: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        targetType: '1',
        companyId: ''
      },
      total: 0,
      tableData: [],
      word:'aaa'
    }

  },
  mounted() {
    this.getCompanyTargetList()
  },
  methods: {
    //选择指标类别
    selectTarget() {
      this.form.pageNum = 1;
      this.form.companyId='';
      this.getCompanyTargetList();
    },
    inputSearch(){ 
      this.form.pageNum = 1; 
      this.getCompanyTargetList();
    },
    // 获取列表状态
    async getCompanyTargetList() {
      if (this.form.companyId!=''&&isNaN(this.form.companyId)) {
        return this.$message.error('企业Id请输入数字');
      }  
      this.listLoading = true
      let data = { 
        Type: this.form.targetType,
        PageNum: this.form.pageNum,
        PageSize: this.form.pageSize,
      };
      if(this.form.companyId!=''){
        data.CompanyId=this.form.companyId;
      }

      let res = await GetCompanyTargetList(data)
      this.listLoading = false
      if (res.Result != 1) {
        return this.$message.error(res.Message)
      }
    
       res.Data.List.forEach(a=>a.editStatus=0);
      //  console.info('List:'+JSON.stringify(    res.Data.List));
      this.tableData = res.Data.List
      this.total = res.Data.TotalCount
    },
    handleCurrentChange(val) {
      if (this.listLoading) return
      this.form.pageNum = val

      this.getCompanyTargetList()
    },
    //翻页
    handleSizeChange(val) {
      if (this.listLoading) return
      this.form.pageNum = 1
      this.form.pageSize = val
      this.getCompanyTargetList()
    },
    //切换tab之前
    tabSelect(activeName, oldActiveName) {
      console.log('activeName:' + activeName + ";oldActiveName:" + oldActiveName);
      if (activeName == "1" || activeName == "2") {
        var url = 'people?t=' + activeName;
        console.log('url:' + url);
        this.$router.push(url);
        return false;
      }
      else {
        return true;
      }
    },
    ediTarget(scope,editStatus)
    {
      console.log(scope);
      var index=scope.$index;
      var row=scope.row;
      // console.log('row:'+JSON.stringify(row));
      console.log('index:'+index);
      row.editStatus=editStatus; 
      row.TargetAmount2=row.TargetAmount;
      this.$set(this.tableData,index,row); 
    },
   async saveTarget(scope)
    {
   
      var row=scope.row; 
      var targetType=this.form.targetType;
      var areaCategory=0;
      if(targetType=="1")
      {
        areaCategory=-1;
      } 
      else if(targetType=="2")
      {
        areaCategory=row.AreaCategory;
      }
      else if(targetType=="3")
      {
        areaCategory=0;
      }
      if (isNaN(row.TargetAmount2)) {
        return this.$message.error('指标金额请输入数字');
      }  
      if (row.TargetAmount<=0&&row.TargetAmount2<=0) {
        return this.$message.error('请输入指标金额');
      }   
      if (row.TargetAmount2=='') {
        return this.$message.error('请输入指标金额');
      }  
       this.listLoading = true
       var data={
        TargetId:row.TargetId,
        TargetType:this.form.targetType,
        AreaCategory:areaCategory,
        CompanyId:row.CompanyId,
        TargetAmount:row.TargetAmount2
       };
       console.log(JSON.stringify(data));
       let res = await UpdateCompanytTarget(data);
       this.listLoading = false
      if (res.Result != 1) {
        return this.$message.error(res.Message);
      }
      this.$message({ message: res.Message, type: "success" });
      this.getCompanyTargetList();
    } 
     
  }
}
</script>

<style lang="scss">
.section-box {
  .customer-list {
    padding: 15px;
    // border: 1px solid red;
  }
}
</style>